import styled from "styled-components";

export const AnalyticsPageStyle = styled.div`
  .card-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
    width: 40%;
  }

  .main-content {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
    margin-top: 20px;
    gap: 50px;
  }

  .custom-dropdown-menu {
    padding: 6px 12px;
    white-space: nowrap;
    font-family: thin-pro, sans-serif;
    cursor: pointer;
    transition: background-color 0.2s ease;
  }
  
  .custom-dropdown-item:hover,
  .custom-dropdown-item:focus {
    background-color: #ed9e44 !important;
    color: #fff !important;
    cursor: pointer;
    z-index: 1;
  }
    
`;
